// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".m-form-description[data-v-474de66a]{line-height:1.6;white-space:pre-wrap}", ""]);
// Exports
module.exports = exports;
